import { ORDER_VINCULATION_LIST, ORDER_VINCULATION_LIST_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function

export const orderVinculationListAction =
  (page, size, filters = {}) =>
  async (dispatch) => {
    try {
      const params = { page, size, ...filters };
      const response = await axiosTokenInstance.get(`/api/reports/linked_up?`, {
        params,
      });

      const { data, status } = response || {};

      dispatch({
        type: ORDER_VINCULATION_LIST,
        payload: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: ORDER_VINCULATION_LIST_ERROR,
        payload: e || {},
      });
    }
  };
